/*
 * @Author: 陈小英 13880788935@163.com
 * @Date: 2024-04-18 13:24:01
 * @LastEditors: 陈小英 13880788935@163.com
 * @LastEditTime: 2024-04-22 10:29:51
 * @FilePath: \operation-center\src\views\websiteAdmin\antireptileSet\components\frequencySet\business\filialeList.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { parseTime } from '@/utils/util'
export const searchForm = {
}

export const form = {
  ip_address: '',
  line_id: undefined, // 使用平台
  expiration_date: [],
  expiration_start_date: '',
  expiration_end_date: '',
  remark: '',
}

export const rules = {
  ip_address: [{ required: true, message: '请输入ip地址', trigger: 'change' }],
  expiration_date: [{ required: true, message: '请选择有效期', trigger: 'change' }],
}
